module.exports = __webpack_public_path__ + "img/cart.31a6c6f1.svg";